export class Base {
  public value = '';
  public errorMessage = '';
  public requiredRule = [(v: string) => !!v || 'Pole je povinné'];
}
